import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import SectionTag from "@/components/SectionTag";
import FaqAccordion from "@/components/FaqAccordion";
import CtaBand from "@/components/CtaBand";
import { FAQS } from "@/data/site";

export default function Faqs() {
  return (
    <main data-testid="faqs-page">
      <Seo
        title="FAQs | Advantage Primary Health, Prescott Valley, AZ"
        description="Answers to common questions about appointments, insurance, same-day care, pediatric care, and more at Advantage Primary Health in Prescott Valley, AZ."
      />

      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-4 pb-12 pt-14 sm:px-6 md:pt-20 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="max-w-3xl"
          >
            <SectionTag number="01" label="Good to Know" />
            <h1 className="mt-5 font-display text-4xl font-extrabold tracking-tight text-brand-navy sm:text-5xl lg:text-6xl">
              Frequently Asked{" "}
              <span className="font-serif italic font-medium text-brand-red">
                Questions
              </span>
            </h1>
            <p className="mt-7 text-base leading-relaxed text-slate-600 sm:text-lg">
              Quick answers about appointments, insurance, same-day care, and
              what to expect at Advantage Primary Health.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-4xl px-4 pb-24 sm:px-6 lg:px-12">
          <Reveal>
            <FaqAccordion items={FAQS} testidPrefix="faq" />
          </Reveal>
        </div>
      </section>

      <CtaBand
        title="Still have questions? Give us a call."
        accent="Give us a call."
        sub="We are happy to help you find the right appointment—book online or call for same-day care."
        testidPrefix="faqs-cta"
      />
    </main>
  );
}
